import styled from 'styled-components';
import { FormattedMarkdown } from '@qover/react-intl';
import {
  BodyMixin,
  Body,
  CaptionMixin,
  Heading2,
  Heading3,
  Heading4,
  Sitemap,
} from '@qover/typography';
// export const PageContainer = styled.div`
//   color: ${props => props.theme.colors.textQuote()};
//   background-color: ${props => props.theme.colors.textQuote(0.03)};
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 40px 0 30px;

//   > h2 {
//     margin: 0;
//   }

//   @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
//     padding: 60px 20px 70px;
//   }
// `;

export const PageTitle = styled(Heading2)`
  margin-top: 0;
  margin-bottom: 40px;
`;

export const SerialNumberTitle = styled(Heading4)`
  &.margin-top-lg {
    margin-top: 80px;
  }
`;

export const Container = styled.div`
  max-width: 800px;
  text-align: center;
  ul {
    display: inline-block;
    text-align: left;
    margin: 0 auto;
  }
`;

export const Caption = styled.div`
  ${CaptionMixin};
  text-transform: uppercase;
  display: none;
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    display: block;
  }
`;

export const PictureDescription = styled(FormattedMarkdown)`
  ${BodyMixin};
  margin: 0 auto;
`;

export const DropText = styled(FormattedMarkdown)`
  ${BodyMixin};
  display: block;
  margin-top: 16px;
  strong {
    color: ${props => props.theme.colors.primary()};
  }
`;

export const PictureCount = styled.p`
  ${BodyMixin};
  margin: 0;
`;

export const InputContainer = styled.div`
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    max-width: 280px;
    margin: 0 auto;
  }
`;

export const Thumb = styled.div`
  border-radius: 3px;
  box-sizing: border-box;
  display: inline-flex;
  height: 100px;
  margin-bottom: 8;
  margin-right: 8;
  padding: 4;
  position: relative;
  width: 100%;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  position: absolute;
  top: 5px;
  right: 5px;
  svg {
    width: 10px;
    height: 10px;
  }
`;

export const Img = styled.img`
  display: block;
  height: 100%;
  object-fit: contain;
  width: auto;
`;

export const DropzoneContainer = styled.div`
  background-color: #fff;
  border-radius: ${props => props.theme.borders.cardRadius};
  box-shadow: 0 2px 4px 0 ${props => props.theme.colors.textQuote(0.15)};
  max-width: 640px;
  padding: 40px;
  margin: 40px 0;
  width: 100%;
  & + div {
    margin-bottom: 20px;
    margin-top: -20px;
  }
`;

export const DropzoneArea = styled.div`
  display: none;
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    display: block;
    border-radius: 4px;
    border: dashed 2px ${props => props.theme.colors.primary(0.2)};
    background-color: ${props => props.theme.colors.primary(0.03)};
    border-radius: ${props => props.theme.borders.cardRadius};
    padding: 80px;
    margin: 40px auto;
    width: 100%;
  }
`;

export const MobileDropzoneArea = styled.div`
  margin-top: 20px;
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    display: none;
  }
`;

export const ThumbContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 130px);
  grid-template-rows: 1fr;
  gap: 20px 20px;
  margin-top: 20px;
`;

export const InnerContainer = styled.div`
  flex: 1 0 auto;
`;
